module.exports = __webpack_public_path__ + "static/img/Ashcroft_L.34c1409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ashcroft_L.jpg
// module id = O8I8
// module chunks = 0